module.exports = __webpack_public_path__ + "media/fonts/materialdesignicons-webfont-0e4e0b3da55fa7faa77b4c2d978008dd.ttf";